<template>
  <div class="about">
    <DashHeader />
    <div class="page">
      <h1>What is the Generic Ballot?</h1>
<p>
The generic Congressional ballot (often shortened to "generic ballot") polling asks whether respondents they plan to vote for a Democrat or Republican in the upcoming Congressional election.  
</p>
<p>
The question is asked without reference to any specific candidate.  This data turns out to be a good, though rough, indicator of the success each party can expect in an upcoming election. </p>
<p>
The generic ballot just before the very close 2016 election was just about tied at roughly Democrat: 46%, Republican: 45.5%.  During Trump’s first two years in office, the generic ballot moved to a 7 point Democratic advantage to roughly Democrat: 49.5%, Republican: 42.5% by the time of the 2018 “Blue Wave” election which flipped the House from a 47 seat Republican advantage to 36 seat Democratic advantage..  For more on this, check out this great article from 2017 by Amy Walter at the Cook Political Report: When Should We Start Paying Attention to the Congressional Generic Ballot Test? (TL;DR: Sometime between summer and Labor Day before the election.)  As I write this in mid-July 2020, the generic ballot has moved an another full two points towards the Democrats since 2016’s Blue Wave and stands at a 9.0 point Democratic advantage.
</p>
<p>
The Daily Snapshot gauge for Generic Ballot shows a maximum of 30 points either way based on the largest generic ballot difference on record (Democrats +32 in July, 1974, right before Nixon resigned).
</p>
      <p>
        <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
      </p>
    </div>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "AboutGenericBallot",
  components: {
    DashHeader
  }
};
</script>
